import { render } from "./SelectFieldFromModel.vue?vue&type=template&id=37ccc66a"
import script from "./SelectFieldFromModel.vue?vue&type=script&lang=js"
export * from "./SelectFieldFromModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__